module.exports = __webpack_public_path__ + "img/app-image.5c10d895.png";